document.addEventListener('DOMContentLoaded', function () {
  const buttonDesktop = document.getElementById('button-tel');
  const phoneNumberDesktop = document.getElementById('phone-number');

  if (buttonDesktop && phoneNumberDesktop) {
    buttonDesktop.addEventListener('click', function () {
      phoneNumberDesktop.classList.remove('hidden');
      buttonDesktop.classList.add('hidden');
    });
  }
});
